// extracted by mini-css-extract-plugin
export var avatar = "profile-module--avatar--zlDKE";
export var avatarSelect = "profile-module--avatarSelect--TueWD";
export var bg = "profile-module--bg--U5ebl";
export var body = "profile-module--body--wzTAO";
export var displayName = "profile-module--displayName--gGybS";
export var root = "profile-module--root--wdctu";
export var selectButton = "profile-module--selectButton--pCFZU";
export var selectButtonL = "profile-module--selectButtonL--GCc9l";
export var selectButtonR = "profile-module--selectButtonR---bb7Q";